const styles = (theme) => ({

  // color
  statusValue: {
    fontSize: '32px',
    fontWeight: 'bold',
    fontFamiry: theme.typography.fontKanit,
  },
  statusText: {
    borderRadius: 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamiry: theme.typography.fontKanit,
    fontSize: 12,
  },
  table: {
    maxWidth: 250,
  },
  hiddenLine: {
    borderBottom: 0,
    fontSize: '12px',
  },

});
export default styles;
